module.exports = __webpack_public_path__ + "static/img/zhhhuarun.8e12609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/zhhhuarun.png
// module id = Mhjm
// module chunks = 93